import React from "react";
import OInputField from "../../components/reusable/OInputField";
import OTextArea from "../../components/reusable/OTextArea";

const MetaStep = ({ register, errors, watch, user, permission }) => {
  const title = watch?.("metaTitle") || "";
  const desc = watch?.("metaDescription") || "";
  const jobTitle = watch?.("title") || "";
  const slug = jobTitle
    .toString()
    .toLowerCase()
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .replace(/[^a-z0-9\s-]/g, "")
    .trim()
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");

  return (
    <div className="grid md:grid-cols-2 gap-6">
      <div>
        <OInputField
          inputLabel="Meta Title"
          name="metaTitle"
          type="text"
          placeholder="Enter meta title for SEO"
          disabled={!(permission?.add || user.role === "admin")}
          register={register("metaTitle")}
          errors={errors}
        />
        <div className="text-xs text-gray-500">{title.length}/60</div>
      </div>
      <OInputField
        inputLabel="Meta Title (Ar)"
        name="metaTitleAr"
        type="text"
        placeholder="Enter Arabic meta title"
        disabled={!(permission?.add || user.role === "admin")}
        register={register("metaTitleAr")}
        errors={errors}
      />
      <div className="md:col-span-2">
        <OTextArea
          inputLabel="Meta Description"
          name="metaDescription"
          placeholder="Enter meta description (recommended ~160 chars)"
          disabled={!(permission?.add || user.role === "admin")}
          register={register("metaDescription")}
          errors={errors}
        />
        <div className="text-xs text-gray-500">{desc.length}/160</div>
      </div>
      <div className="md:col-span-2">
        <OTextArea
          inputLabel="Meta Description (Ar)"
          name="metaDescriptionAr"
          placeholder="Enter Arabic meta description"
          disabled={!(permission?.add || user.role === "admin")}
          register={register("metaDescriptionAr")}
          errors={errors}
        />
      </div>
      <OInputField
        inputLabel="Meta Keywords (comma separated)"
        name="metaKeyword"
        type="text"
        placeholder="e.g., marketing manager, abu dhabi jobs"
        disabled={!(permission?.add || user.role === "admin")}
        register={register("metaKeyword")}
        errors={errors}
      />
      <OInputField
        inputLabel="Meta Keywords (Ar)"
        name="metaKeywordAr"
        type="text"
        placeholder="e.g., مدير تسويق, وظائف أبو ظبي"
        disabled={!(permission?.add || user.role === "admin")}
        register={register("metaKeywordAr")}
        errors={errors}
      />
      <div className="md:col-span-2">
        <label className="block mb-2 text-sm font-medium text-gray-900">
          Slug (preview)
        </label>
        <div className="text-sm text-gray-700 bg-gray-50 border border-gray-200 rounded-md p-2">
          {slug || "-"}
        </div>
      </div>
    </div>
  );
};

MetaStep.fields = []; // Optionals

export default MetaStep;
